module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"type":"Type","amount":"Amount","setDate":"Set date","pledgee":"Pledgee"},"et":{"type":"Type","amount":"Amount","setDate":"Set date","pledgee":"Pledgee"},"ru":{"type":"Type","amount":"Amount","setDate":"Set date","pledgee":"Pledgee"}}')
  delete Component.options._Ctor
}
